import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";

const Contacts = () => {
  return (
    <Container className="py-4">
      <h2 className="mb-4 text-center">Контакты</h2>

      <Row className="mb-5">
        <Col md={4}>
          <Card className="mb-3">
            <Card.Header as="h5">Адреса магазинов</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>г. Волгоград, ул. Ткачёва, 11<br />
                            8 (8442) 96-24-41<br />
                            +7 (906) 400-09-30<br />
              </ListGroup.Item>
              <ListGroup.Item>г. Волгоград, ул. Кузнецова, 20 <br />
                            8 (8442) 50-25-85<br />
                            +7 (927) 510-25-85<br />

              </ListGroup.Item>
              <ListGroup.Item>г. Волгоград, ул. Вершинина, 1<br />
                            8 (8442) 50-35-85<br />
                            +7 (927) 542-25-85<br />
              </ListGroup.Item>
              <ListGroup.Item>г. Волгоград, проспект Героев Сталинграда, 49<br />                            
                            +7 (937) 085-25-85<br />
              </ListGroup.Item> 
              <ListGroup.Item>г. Волгоград, Университетский проспект, 107<br />                            
                            +7 (937) 555-25-85<br />
              </ListGroup.Item> 
              <ListGroup.Item>г. Волгоград, улица Николая Отрады, 10<br />                            
                            +7 (961) 083-14-08<br />
              </ListGroup.Item>
            </ListGroup>
          </Card>



          
        </Col>

        <Col md={8}>
          <h5 className="mb-3">Магазины на карте</h5>
          <div style={{ width: "100%", height: "450px" }}>
            <iframe
              title="Магазины EVO7"
              src="https://yandex.ru/map-widget/v1/?um=constructor%3Afe58a9e84db16861dbc9109b64c96731b9d3bcb814e947af42ad2994ec49340d&amp;source=constructor" 
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </Col>        
      </Row>
      <Row>
      <Col md={8}>
          <Card>
            <Card.Header as="h5">Телефоны</Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      +7 (927) 533-25-85 <br />
                      <small>Служба работы с маркетплейсами</small>
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
                <Col md={6}>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      +7 (927) 506-25-85 <br />
                      <small>Отдел по работе с оптовыми клиентами</small>
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-3">
              <Card.Header as="h5">Электронная почта</Card.Header>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <a href="mailto:info@evo7.ru">info@evo7.ru</a>
                </ListGroup.Item>
              </ListGroup>
            </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contacts;